import * as React from "react";

function SvgMediaNav(props) {
  return <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={12} cy={12} r={12} fill="#fff" /><circle cx={12} cy={12} r={11} stroke="#21201B" strokeWidth={2} /><path d="M9.422 7.289v9.955l7.823-4.977-7.823-4.978z" fill="#21201B" /></svg>;
}

export default SvgMediaNav;